module.exports = {"430212100":"渌口镇","430212101":"朱亭镇","430212106":"古岳峰镇","430212107":"淦田镇","430212108":"龙门镇","430212109":"龙潭镇","430212110":"南洲镇","430212111":"龙船镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430212.json
// module id = 1942
// module chunks = 0